import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=a479979e&scoped=true&"
import script from "./Limits.vue?vue&type=script&lang=js&"
export * from "./Limits.vue?vue&type=script&lang=js&"
import style0 from "./Limits.vue?vue&type=style&index=0&id=a479979e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a479979e",
  null
  
)

export default component.exports